import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadableMobileMuroModalPopup = lazy(() =>
  retry(() => import('./MobileMuroModal'))
);

interface Props {
  requestClose: () => void;
}

const LazyMobileMuroModalPopup: React.FC<Props> = props => (
  <ErrorBoundary debugComponent="LazyMobileMuroModalPopup">
    <Suspense
      fallback={<LoadingIndicator view={'llama'} withOverlay usePortal />}
    >
      <LoadableMobileMuroModalPopup {...props} />
    </Suspense>
  </ErrorBoundary>
);
LazyMobileMuroModalPopup.displayName = 'LazyMobileMuroModalPopup';

export default LazyMobileMuroModalPopup;
